import { useState } from 'react'; 
import { Box,Typography,Stack,Container, Button, Grid} from '@mui/material';   
import { styled } from '@mui/material/styles'; 
import Nftshot from '../components/Nftshot';  
import Nftsnew from '../components/Nftsnew';  
import Introduce from '../sections/about/Introduce';   
import ColletionsNew from '../components/ColletionsNew';
import ColletionsHot from '../components/ColletionsHot';
export default function HomePage() {
  return ( 
    <Container>
                   <Box >  
                     <Nftshot />
                     <Nftsnew />
                     <ColletionsHot />
                     <ColletionsNew />
                   </Box>
                   <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}></Stack>
                {/* <Introduce  />   */}
      </Container>
  );
}
